import produce from 'immer';

import { createReducer } from 'utils/redux';
import { CHANNEL_TYPE_INSTAGRAM, CHANNEL_TYPE_TIKTOK, CHANNEL_TYPE_YOUTUBE } from 'utils/channels';

import { ConsentReducerState } from 'redux-store/types/ConsentReducer.type';

const IG_CONSENT_RETRIEVED = 'consentReducer/IG_CONSENT_RETRIEVED';
const YT_CONSENT_RETRIEVED = 'consentReducer/YT_CONSENT_RETRIEVED';
const TT_CONSENT_RETRIEVED = 'consentReducer/TT_CONSENT_RETRIEVED';

const initialState: ConsentReducerState = {
  consents: {
    instagram: process.env.NODE_ENV === 'development',
    tiktok: process.env.NODE_ENV === 'development',
    youtube: process.env.NODE_ENV === 'development'
  }
};

export function setInstagramConsent(hasConsent: boolean) {
  return {
    type: IG_CONSENT_RETRIEVED,
    payload: {
      hasConsent
    }
  };
}

export function setYoutubeConsent(hasConsent: boolean) {
  return {
    type: YT_CONSENT_RETRIEVED,
    payload: {
      hasConsent
    }
  };
}

export function setTikTokConsent(hasConsent: boolean) {
  return {
    type: TT_CONSENT_RETRIEVED,
    payload: {
      hasConsent
    }
  };
}

export default createReducer<ConsentReducerState, any>('consentReducer', initialState, {
  [IG_CONSENT_RETRIEVED]: (state, { hasConsent }) => produce(state, (draft) => {
    // eslint-disable-next-line no-param-reassign
    draft.consents[CHANNEL_TYPE_INSTAGRAM] = hasConsent;
  }),
  [YT_CONSENT_RETRIEVED]: (state, { hasConsent }) => produce(state, (draft) => {
    // eslint-disable-next-line no-param-reassign
    draft.consents[CHANNEL_TYPE_YOUTUBE] = hasConsent;
  }),
  [TT_CONSENT_RETRIEVED]: (state, { hasConsent }) => produce(state, (draft) => {
    // eslint-disable-next-line no-param-reassign
    draft.consents[CHANNEL_TYPE_TIKTOK] = hasConsent;
  })
});
